import { Link } from "react-router-dom";
import React from "react";
import "../styles/AIMachineLearning.css";

const aiServices = [
  ["Predictive Intelligence", "Forecast demand, identify risk and uncover patterns in operational data", "◌"],
  ["Generative AI Experiences", "Create grounded assistants that help teams search, summarize and act", "✳"],
  ["Computer Vision", "Understand images and video for quality checks, safety and visual search", "◈"],
];

const AIMachineLearning = () => (
  <main className="ai-page">
    <section className="ai-hero">
      <div className="ai-hero-copy">
        <span className="ai-kicker">INTELLIGENCE, BUILT FOR WORK</span>
        <h1>Make your data work <em>smarter</em></h1>
        <p>We turn machine learning and generative AI into useful products that help people make better decisions and move faster.</p>
        <Link to="/contact">Explore an AI use case <b>↗</b></Link>
      </div>
      <div className="ai-visual" aria-label="Abstract artificial intelligence network visualization">
        <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1300&q=90" alt="Abstract AI neural network visualization" />
        <div className="ai-orbit ai-orbit-one" />
        <div className="ai-orbit ai-orbit-two" />
        <div className="ai-signal ai-signal-one">MODEL<br /><strong>READY</strong></div>
        <div className="ai-signal ai-signal-two">DATA <strong>→</strong> INSIGHT</div>
      </div>
    </section>

    <section className="ai-capabilities">
      <div className="ai-section-heading"><span>FROM EXPERIMENT TO IMPACT</span><h2>Practical AI for real teams</h2><p>Every solution starts with a clear business outcome, thoughtful data design and a path to responsible deployment</p></div>
      <div className="ai-service-grid">
        {aiServices.map(([title, description, symbol], index) => (
          <article className="ai-service-card" key={title} style={{ "--card-delay": `${index * 120}ms` }}>
            <div className="ai-symbol">{symbol}</div><span className="ai-card-index">0{index + 1}</span>
            <h3>{title}</h3><p>{description}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="ai-lab">
      <div className="ai-lab-image"><img src="https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?auto=format&fit=crop&w=1000&q=85" alt="Machine learning code on a developer screen" loading="lazy" /></div>
      <div><span className="ai-kicker">A BETTER WAY TO ADOPT AI</span><h2>Small, measurable steps. Meaningful change.</h2><p>We help you choose the right use case, build a working proof of value, connect it to trusted data and monitor its performance over time.</p>
        <ul><li>Use case discovery and data readiness</li><li>Custom model and product development</li><li>Evaluation, governance and ongoing improvement</li></ul>
      </div>
    </section>
    <section className="ai-cta"><span>HAVE A CHALLENGE IN MIND?</span><h2>Let’s find where AI can help</h2><Link to="/contact">Talk with our team →</Link></section>
  </main>
);

export default AIMachineLearning;